import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Button, Container, Row, Col, Spinner, Alert } from "react-bootstrap";
import axios from "axios";

export default function Exames() {
  const navigate = useNavigate();
  const [exames, setExames] = useState([]);
  const [paciente, setPaciente] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");

  useEffect(() => {
    const stored = localStorage.getItem("paciente");
    if (!stored) {
      navigate("/");
      return;
    }

    const pacienteData = JSON.parse(stored);
    setPaciente(pacienteData);

    // ==============================
    // Configuração dinâmica
    // ==============================
    const systemType = process.env.REACT_APP_SYSTEM_TYPE || "viva";
    const baseURL = process.env.REACT_APP_API_URL;

    let endpoint = "";
    let axiosConfig = {};

    if (systemType === "viva") {
      // Endpoint tradicional (controller.php)
      endpoint = `${baseURL}/v16_view/controller/controller.php`;
      axiosConfig = {
        params: {
          p1: "pegaResultadosPaciente",
          p2: pacienteData.codigo,
          empresa: 13,
        },
      };
    } else if (systemType === "synclab") {
      // Novo endpoint Synclab
      endpoint = `${baseURL}/app/pegaresultadospaciente/${pacienteData.codigo}`;
      axiosConfig = {
        auth: {
          username: "sync-oct",
          password: "d74e50bc-0d39-3dc5-8fe3-160ecea0944c",
        },
      };
    }

    // ==============================
    // Requisição
    // ==============================
    axios
      .get(endpoint, axiosConfig)
      .then((response) => {
        console.log("📦 Resposta API:", response.data);

        let lista = [];

        if (systemType === "synclab") {
          const data = response.data;
          if (Array.isArray(data.resultados)) {
            lista = data.resultados;
          } else {
            console.warn("⚠️ API Synclab não retornou campo 'resultados'");
          }
        } else {
          if (Array.isArray(response.data)) {
            lista = response.data;
          } else {
            console.warn("⚠️ API Viva não retornou array de exames");
          }
        }

        setExames(lista);
      })
      .catch((error) => {
        console.error("❌ Erro ao buscar exames:", error);

        if (error.response) {
          console.log("📡 STATUS:", error.response.status);
          console.log("📦 BODY:", error.response.data);
          setErro(
            `Erro ${error.response.status}: ${error.response.data?.msg || "Falha ao buscar resultados."
            }`
          );
        } else if (error.request) {
          console.log("🚫 Sem resposta da API:", error.request);
          setErro("Servidor não respondeu. Verifique a API.");
        } else {
          console.log("⚠️ Erro ao configurar requisição:", error.message);
          setErro("Falha interna ao tentar buscar exames.");
        }
      })

      .finally(() => {
        setLoading(false);
      });
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("paciente");
    navigate("/");
  };

  return (
    <div className="d-flex flex-column min-vh-100 bg-light">
      {/* ============================
          Cabeçalho
      ============================ */}
      <header className="bg-white border-bottom shadow-sm py-3">
        <Container className="d-flex align-items-center justify-content-between">
          <img
            src="https://synclabweb.unisync.com.br/themes/gradient/assets/images/logo01.jpg"
            alt="Unisync"
            style={{ width: "100px" }}
          />
          <h5 className="mb-0 text-center flex-grow-1 fw-semibold text-primary">
            Portal de Resultados - Unisync
          </h5>
          <div className="text-center text-md-end mt-3 mt-md-0">
            <Button variant="outline-danger" onClick={handleLogout}>
              Sair
            </Button>
          </div>
        </Container>
      </header>

      {/* ============================
          Conteúdo principal
      ============================ */}
      <Container className="mt-4 mb-4 flex-grow-1">
        <div className="d-flex justify-content-between align-items-center mb-4 flex-column flex-md-row">
          <div className="text-center text-md-start">
            <h5>
              Olá, <strong>{paciente?.nome}</strong>
            </h5>
          </div>
        </div>

        {loading ? (
          <div className="text-center mt-5">
            <Spinner animation="border" variant="primary" />
            <p className="mt-3">Buscando seus exames...</p>
          </div>
        ) : erro ? (
          <Alert variant="danger" className="text-center">
            {erro}
          </Alert>
        ) : exames.length === 0 ? (
          <p className="text-center text-muted">Nenhum resultado disponível no momento.</p>
        ) : (
          <Table striped bordered hover responsive className="shadow-sm bg-white">
            <thead className="table-primary">
              <tr>
                <th>Data da Requisição</th>
                <th>Exame</th>
                <th>Setor</th>
                <th>Unidade</th>
                <th>Situação</th>
                <th>Resultado</th>
              </tr>
            </thead>
            <tbody>
              {exames.map((exame, index) => (
                <tr key={index}>
                  <td>{exame.data_requisicao}</td>
                  <td>{exame.exame}</td>
                  <td>{exame.setor}</td>
                  <td>{exame.unidade}</td>
                  <td>
                    {exame.situacao === "Pronto" ? (
                      <span className="badge bg-success">Pronto</span>
                    ) : (
                      <span className="badge bg-warning text-dark">Pendente</span>
                    )}
                  </td>
                  <td>
                    {exame.pdf_link ? (
                      <a
                        href={exame.pdf_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-primary"
                      >
                        Ver PDF
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}

        {/* ============================
            Propagandas
        ============================ */}
        <Row className="mt-4 g-3">
          <Col md={6}>
            <img
              src="https://synclabweb.unisync.com.br/img1.jpeg"
              alt="Propaganda 1"
              className="img-fluid rounded shadow-sm"
            />
          </Col>
          <Col md={6}>
            <img
              src="https://synclabweb.unisync.com.br/img2.jpeg"
              alt="Propaganda 2"
              className="img-fluid rounded shadow-sm"
            />
          </Col>
        </Row>
      </Container>

      {/* ============================
          Rodapé
      ============================ */}
      <footer className="bg-white text-center py-3 border-top mt-auto position-relative shadow-sm">
        <p className="mb-1 text-secondary">
          © 2025 Unisync. Todos os direitos reservados.
        </p>
        <small className="text-muted">
          Atendimento humanizado, tecnologia de ponta. Acesse nosso site:{" "}
          <a
            href="https://unisync.com.br/"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.unisync.com.br
          </a>
        </small>
        <br />
        <small className="text-muted">
          Desenvolvido por{" "}
          <a
            href="https://www.octussistemas.com.br/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Octus Sistemas
          </a>
        </small>

        <img
          src="https://www.octussistemas.com.br/assets/img/logo.png"
          alt="Octus Sistemas"
          style={{
            position: "absolute",
            right: "35px",
            bottom: "10px",
            height: "90px",
            opacity: 0.8,
          }}
        />
      </footer>
    </div>
  );
}
